import React from 'react';
import { useTranslation } from 'react-i18next';

interface HelpLoadStateProps {
    loading: boolean;
    failed: boolean;
    retry: () => void;
}

/** Loading and failure states of the lazily loaded article content. A failed
 *  load says so and offers a retry — it never renders as an empty article. */
const HelpLoadState = ({ loading, failed, retry }: HelpLoadStateProps) => {
    const { t } = useTranslation();
    if (failed) {
        return (
            <div role={'alert'} className={'text-sm text-foreground/80 flex flex-wrap items-center gap-3'}>
                <span>{t('help.load_error')}</span>
                <button className={'text-sm text-primary underline underline-offset-2'} onClick={retry}>
                    {t('help.retry')}
                </button>
            </div>
        );
    }
    if (loading) return <p className={'text-sm text-foreground/50'}>{t('help.loading')}</p>;
    return null;
};

export default HelpLoadState;
